import {toSecureCardNumber} from '@logistics-frontend/core/formatters'

import {PaymentCard} from './types'

export * from './types'

export function formatCardNumber(payment: PaymentCard): string {
  return toSecureCardNumber(payment.number, payment.system)
}
